import { UploadFileInfo } from '@progress/kendo-react-upload';

export function onSaveRequest(
  files: UploadFileInfo[],
): Promise<{ uid: string }> {
  const currentFile = files[0];
  const uid = currentFile.uid;

  return new Promise<{ uid: string }>((resolve, reject) => {
    if (
      currentFile.validationErrors &&
      currentFile.validationErrors.length > 0
    ) {
      reject({ uid });
    } else {
      resolve({ uid });
    }
  });
}

export function onRemoveRequest(
  files: UploadFileInfo[],
): Promise<{ uid: string }> {
  const currentFile = files[0];
  const uid = currentFile.uid;
  return new Promise<{ uid: string }>(resolve => {
    resolve({ uid });
  });
}

export const download = (file: File, fileName: string) => {
  const href = URL.createObjectURL(file);
  const link = document.createElement('a');
  link.href = href;
  link.setAttribute('download', fileName);
  link.click();
  URL.revokeObjectURL(href);
};
